import styled from '@emotion/styled';
import palette from 'theme/palette';
import pxToEm from 'theme/pxToEm';

const getWrapperStyles = (compact?: boolean) => {
  if (compact) {
    return `
      margin-top: 0;
      padding-top: 0;
      border-bottom: 1px solid ${palette.grey[300]};
      padding-bottom: ${pxToEm(16)};
      max-height: ${pxToEm(185)};
      overflow-x: auto;
      &::-webkit-scrollbar {
          display: none;
      }
      -ms-overflow-style: none;
      scrollbar-width: none;
    `;
  } else {
    return `
      margin-top: ${pxToEm(16)};
      padding-top: ${pxToEm(16)};
      border-top: 1px solid ${palette.grey[300]};
    `;
  }
};

export const AskProductOrderDetailsWrapper = styled.div<{
  isOrderDetailsOpen: boolean;
  compact?: boolean;
}>`
  display: ${({ isOrderDetailsOpen }) =>
    isOrderDetailsOpen ? 'grid' : 'none'};
  ${({ compact }) => getWrapperStyles(compact)}

  gap: ${pxToEm(16)};
  grid-template-columns: ${({ compact }) =>
    compact ? 'repeat(1, 1fr)' : 'repeat(5, 1fr);'};
`;
